import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/fastvaluedeal-cta';

const buttonPrimaryHtml = buttonPrimary({
  text: 'GET 80% DISCOUNT',
  backgroundColor: '#17BE4F',
  radius: 8,
  iconPrefix: {
    show: false,
  },
  iconSuffix: {
    show: false,
  },
  subBtn: {
    show: false,
    text: '',
  },
});

const html = `
<div
  class="fvd-cta-content container"
  data-attribute="fvd-cta-content"
>
  <div class="fvd-cta-left">
    <div class="fvd-cta__logo" data-attribute="fvd-cta__logo">
      <img
        data-attribute="fvd-cta__logo-img"
        src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e083858d3a52a625efc9.png"
        alt="logo"
      />
    </div>
    <div class="fvd-cta__rating" data-attribute="fvd-cta__rating">
      <img
        data-attribute="fvd-cta__avatars-img"
        src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e0a0b8c5579f6205b6ff.png"
        alt="avatars"
      />
      <img
        data-attribute="fvd-cta__stars-img"
        src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e0937c9449cf5eb771c9.png"
        alt="stars"
      />
      <p
        class="fvd-cta__rating-text"
        data-attribute="fvd-cta__rating-text"
      >
        4.7 Average Rating
      </p>
    </div>
  </div>
  ${buttonPrimaryHtml}
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000000',
  textColor: '#FFFFFF',
});
